import { memo } from 'react';

import classNames from 'classnames';

import { PresentationModal } from '@features/PresentationModal';
import { WidgetModalController } from '@features/WidgetModalController/WidgetModalController';

import cls from './Dashboard.module.css';
import { DashboardProjectName } from './DashboardProjectName';
import { useDashboard } from './useDashboard';
import { Tabs } from '../../components/newUI/Tabs/Tabs';

interface DashboardProps {
    classes?: string;
    projectId?: number;
    variant?: 'page' | 'embedded';
}

export const Dashboard = memo(({ classes, projectId, variant = 'page' }: DashboardProps) => {
    const {
        tabsList,
        activeTab,
        onTabChange,
        isLoading,
        tabsContentMapping,
        information,
        tabs,
        onClosePresentation,
        presentationState,
    } = useDashboard({ projectId });

    return (
        <div
            className={classNames(cls.Dashboard, [classes], {
                [cls.embedded]: variant === 'embedded',
            })}
        >
            <DashboardProjectName isLoading={isLoading} projectName={information.name} />
            {tabs.show && (
                <Tabs
                    tabsList={tabsList}
                    activeTab={activeTab}
                    onChange={onTabChange}
                    isLoading={isLoading}
                />
            )}

            <div className={cls.content}>{tabsContentMapping[activeTab]}</div>
            {presentationState.isOpen && (
                <PresentationModal
                    isOpen={presentationState.isOpen}
                    videoSrc={presentationState.videoSrc}
                    header={presentationState.header}
                    subHeader={presentationState.subheader}
                    onClosePresentation={onClosePresentation}
                    tariffQuery={presentationState.tariffQuery}
                />
            )}
            <WidgetModalController />
        </div>
    );
});
